import { Box, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import "./styles.scss";
import {
  ExperiencesAvailabilityAutocompleteResult,
  ExperienceTagCount,
  IResult,
} from "redmond";
import { AvailabilityAutocomplete } from "../AvailabilityAutocomplete";
import { ParsedExperiencesAvailabilityAutocompleteResult } from "../AvailabilityAutocomplete/component";
import { MobileKeywordSearch } from "../MobileKeywordSearch";
import { SEARCH_BY } from "./constants";

export interface IKeywordSearchProps {
  hideSearchBar?: boolean;
  title: string;
  setSelectedGroupedExperience: (option: ExperienceTagCount) => void;
  isMobile?: boolean;
  location: IResult | null;
}

const getSelectedOption = (
  option: ParsedExperiencesAvailabilityAutocompleteResult | null,
  value: ExperiencesAvailabilityAutocompleteResult | null
) => {
  const selection = value ? value.id : null;
  const opt = option ? option.id : null;
  return !!selection && !!opt && selection === opt;
};

export const KeywordSearch = (props: IKeywordSearchProps) => {
  const {
    hideSearchBar,
    title,
    setSelectedGroupedExperience,
    isMobile,
    location,
  } = props;

  return (
    <Box className="experiences-availability-keyword-search-container">
      <Box className={clsx("experiences-availability-keyword-search-control")}>
        <Box className="search-components-section">
          <Typography variant="h2" className="search-title">
            {title}
          </Typography>
          {!hideSearchBar &&
            (isMobile ? (
              <MobileKeywordSearch
                setSelectedGroupedExperience={setSelectedGroupedExperience}
                location={location}
              />
            ) : (
              <AvailabilityAutocomplete
                label={SEARCH_BY}
                getOptionSelected={getSelectedOption}
                setSelectedGroupedExperience={setSelectedGroupedExperience}
                location={location}
              />
            ))}
        </Box>
      </Box>
    </Box>
  );
};
